import { Box } from "@mui/material";
import type { ReactNode } from "react";
import type {
	UtilityConsumptionMillRolling,
	UtilityConsumptionMeterGap,
	UtilityConsumptionMiniBucket,
	UtilityConsumptionSummary,
} from "../../shared/consumption/models/UtilityConsumption";
import { ConsumptionTrendCard } from "./at-a-glance/ConsumptionTrendCard";
import { PairedDaysChart } from "./at-a-glance/PairedDaysChart";
import { RollingEfficiencyCard } from "./at-a-glance/RollingEfficiencyCard";
import { TotalsSummaryCard } from "./at-a-glance/TotalsSummaryCard";

interface AtAGlanceProps {
	summary: UtilityConsumptionSummary;
	millRolling: UtilityConsumptionMillRolling[];
	meterGaps: UtilityConsumptionMeterGap[];
	buckets: UtilityConsumptionMiniBucket[];
	showCost: boolean;
	efficiencyCard?: ReactNode;
}

export const AtAGlance = ({
	summary,
	millRolling,
	meterGaps,
	buckets,
	showCost,
	efficiencyCard,
}: AtAGlanceProps) => (
	<Box
		component="section"
		aria-label="At a Glance"
		sx={{ containerType: "inline-size", minWidth: 0 }}
	>
		<Box
			sx={{
				display: "grid",
				gridTemplateAreas: '"comparison" "totals" "efficiency" "chart"',
				gridTemplateColumns: "minmax(0, 1fr)",
				gap: 1,
				minWidth: 0,
				maxWidth: "100%",
				"@container (min-width: 600px)": {
					gridTemplateAreas:
						'"comparison comparison" "totals efficiency" "chart chart"',
					gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
				},
				"@container (min-width: 1400px)": {
					gridTemplateAreas: '"comparison totals efficiency chart"',
					gridTemplateColumns:
						"minmax(340px, 1.4fr) repeat(2, minmax(320px, 1.5fr)) minmax(400px, 2fr)",
				},
			}}
		>
			<ConsumptionTrendCard summary={summary} meterGaps={meterGaps} />
			<TotalsSummaryCard
				summary={summary}
				meterGaps={meterGaps}
				showCost={showCost}
			/>
			{efficiencyCard ?? (
				<RollingEfficiencyCard
					summary={summary}
					meterGaps={meterGaps}
					millRolling={millRolling}
					showCost={showCost}
				/>
			)}
			<PairedDaysChart
				buckets={buckets}
				averageGallons={summary.ThirtyDayAverageGallons}
			/>
		</Box>
	</Box>
);
